import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faMinus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Activity, ActivityType } from '@spike/activity-model';
import {
    ACTIVITY_ICON_COLORS_MAP,
    ACTIVITY_ICON_FOREGROUND_COLORS_MAP,
    ACTIVITY_ICON_MAP,
    ACTIVITY_TITLE_MAP
} from 'components/Activities/Icon/ActivityIcon';
import React from 'react';
import styles from './RecentActivitiesPanel.module.scss';

interface RecentActivityRowProps {
    activity: Activity;
    added: boolean;
    /* eslint-disable no-unused-vars */
    onAdd: (activity: Activity) => void;
    onRemove: (activity: Activity) => void;
    /* eslint-enable no-unused-vars */
}

const RecentActivityRowComponent: React.FC<RecentActivityRowProps> = ({ activity, added, onAdd, onRemove }) => {
    const activityType = activity.type as ActivityType;
    const icon = ACTIVITY_ICON_MAP[activityType];
    const iconColor = ACTIVITY_ICON_COLORS_MAP[activityType];
    const iconForegroundColor = ACTIVITY_ICON_FOREGROUND_COLORS_MAP[activityType];

    const toggleHandler = React.useCallback(
        () => (added ? onRemove(activity) : onAdd(activity)),
        [added, onAdd, onRemove, activity]
    );

    return (
        <div className={styles.item}>
            <div
                className={styles.activityIcon}
                style={
                    {
                        '--icon-color': iconColor,
                        '--icon-foreground': iconForegroundColor
                    } as React.CSSProperties
                }
            >
                <FontAwesomeIcon icon={icon} />
            </div>

            <div className={styles.activityInfo}>
                <p className={styles.activityType}>{ACTIVITY_TITLE_MAP[activityType] ?? activityType}</p>
                <p className={styles.activityTime}>{activity.date.format('h:mm a')}</p>
            </div>

            <button
                type="button"
                className={added ? styles.removeButton : styles.addButton}
                onClick={toggleHandler}
                aria-label={added ? 'Remove from report' : 'Add to report'}
            >
                <FontAwesomeIcon icon={added ? faMinus : faPlus} />
            </button>
        </div>
    );
};

export const RecentActivityRow = React.memo(RecentActivityRowComponent);
